import {
    Dialog,
    DialogTitle,
    Button,
    DialogContent,
    Grid,
    Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useStoreAppColor } from '@state/useStoreAppColor';
import { WarningRounded } from '@mui/icons-material';
import theme from '@styles/theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    btn: {
        width: '100%',
        marginTop: 8,
        height: 36,
        fontSize: 16, 
    },
    paper: {
        width: '95%',
        margin: 0
    }
});

const AlertResetDialog = ({ open, onConfirm, onCancel }) => {
    const { appColor } = useStoreAppColor(state => ({
        appColor: state.appColor
    }));
    const classes = useStyles(appColor);
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            classes={{
                paper: `${classes.paper}`
            }}>
            <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
                <WarningRounded
                    style={{ color: appColor.primaryThemeColor, fontSize: 32  }}
                />
            </DialogTitle>
            <DialogContent style={{paddingBottom: theme.spacing(6)}}>
                <Grid container direction="row" style={{ textAlign: 'center' }}>
                    <Grid item style={{ width: '100%', textAlign: 'center', marginBottom: theme.spacing(4), fontSize: 17 }}>
                        <Typography variant="body1">
                            {t('infoResetModal')}
                        </Typography>
                    </Grid>
                    <Grid item style={{ width: '100%', marginBottom: theme.spacing(2) }}>
                        <Button
                            onClick={onConfirm}
                            className={classes.btn}
                            sx={{
                                color: appColor.secondaryFontColor,
                                backgroundColor: appColor.addButton,
                                '&:hover': {
                                  backgroundColor: appColor.addButton,
                                },
                              }}
                              variant="contained">
                           {t('btnYesInfoResetModal')}
                        </Button>
                    </Grid>
                    <Grid item style={{ width: '100%' }}>
                        <Button
                            onClick={onCancel}
                            className={classes.btn}
                            style={{
                                backgroundColor: appColor.primaryThemeColor,
                                color: 'white',
                                "&:hover": {
                                    background: appColor.primaryThemeColor,
                                }
                            }}
                            variant="outlined">
                            {t('btnNoInfoResetModal')}
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default AlertResetDialog;